import { Button, ButtonProps } from 'antd';
import { FC, ReactNode } from 'react';
import './style.scss';

export interface ButtonWrapProps extends Omit<ButtonProps, 'color' | 'variant'> {
  width?: number | 'full';
  height?: number;
  children: ReactNode;
  color?: 'primary' | 'danger' | 'black' | 'gray' | 'green';
  variant?: 'filled' | 'outlined' | 'text';
}

const ButtonWrap: FC<ButtonWrapProps> = (props) => {
  const { variant = 'filled', className, children, color = 'primary', width, height, ...otherProps } = props;

  let buttonClassNames = 'custom_button';

  if (className) {
    buttonClassNames = `${buttonClassNames} ${className}`;
  }

  if (color) {
    buttonClassNames = `${buttonClassNames} custom_button-${color}`;
  }
  if (otherProps.disabled) {
    buttonClassNames = `${buttonClassNames} custom_button-disable-${otherProps.disabled}`;
  }

  if (variant) {
    buttonClassNames = `${buttonClassNames} custom_button-${variant}`;
  }

  if (width) {
    buttonClassNames = `${buttonClassNames} width-${width}`;
  }

  if (height) {
    buttonClassNames = `${buttonClassNames} height-${height}`;
  }

  return (
    <>
      <Button {...otherProps} className={buttonClassNames} variant={variant}>
        {children}
      </Button>
    </>
  );
};

export default ButtonWrap;
